export function validarEmail(email: string) {
  // Regex para validar o formato do e-mail
  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Testa o e-mail em relação à expressão regular
  return regexEmail.test(email);
}
